import { useEffect, useState } from "react";

const STORAGE_KEY = "dp_maintenance_bypass";

/**
 * Grants a permanent (per-browser) bypass of maintenance/coming-soon mode
 * when the page is loaded with ?key=<REACT_APP_MAINTENANCE_BYPASS_KEY>.
 * The key is stripped from the URL immediately so it doesn't linger in
 * the address bar, browser history, or get shared when copying the link.
 */
export function useMaintenanceBypass(): boolean {
  const [bypassed, setBypassed] = useState(
    () => localStorage.getItem(STORAGE_KEY) === "granted",
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const key = params.get("key");
    const expectedKey = process.env.REACT_APP_MAINTENANCE_BYPASS_KEY;

    if (key && expectedKey && key === expectedKey) {
      localStorage.setItem(STORAGE_KEY, "granted");
      setBypassed(true);

      params.delete("key");
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : "") +
        window.location.hash;
      window.history.replaceState({}, "", newUrl);
    }
  }, []);

  return bypassed;
}
